import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomerService } from '../../../services/customer.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CompanyGroup, CustomerRegistrationCompanyGroup } from '../../../models/customer-model';
import { CommonFunction } from '../../../common/common-functions';
import { UserLog } from '../../../models/common-model';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'ngx-create-compay-group',
  templateUrl: './create-compay-group.component.html',
  styleUrls: ['./create-compay-group.component.scss']
})
export class CreateCompayGroupComponent implements OnInit {
  companyGroupForm: FormGroup; 
  title='';
  custMasterList : Array<any> = [];
  allCustArr: Array<any> = []; // List of all customers
  custArr: Array<any> = []; // List of all customers
  custNameArr: Array<any> = [];  
  submitted = false;
  isDisabled = false;
  loading=false;
  custid = 0;
  CgId: number;
  sub: any;
  fromprofilepage : number = 0;
  comapniesUnderGroup: Array<any> = [];
  cgName: string;


  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private _router: Router,
    private custservice: CustomerService,    
    private _auth: AuthenticationService,
    private commonfunction: CommonFunction,
    private commservice: CommonService,
  ) { }

  ngOnInit(): void {
   
        this.sub = this.route.params.subscribe(params => {
        const id = this._auth.decryptData(params['cgId']) || 0;
        this.CgId = id['cgId'] || 0;
        this.title = ((this.CgId !== undefined && this.CgId > 0) ? 'Edit' : 'Create') + ' - Company Group';
       
        if(this.CgId >0)
        {
          this.SetFormData(this.CgId);                
          
        }
        this.getCompanyList(0);
      });

    

    this.companyGroupForm = this.formBuilder.group({
      GroupName: ['', [Validators.required]],
      CompanyNames:[,[Validators.required]]
    });


  }

  SetFormData(cgId: number)
  {
    this.custservice.getGroupCompanyByLogin(0, this.CgId).subscribe(
      (data3) => {
        
        if (data3['isError'] === false && data3['code'] === 200) {
        
          this.comapniesUnderGroup =  data3['payload'];
          if(this.comapniesUnderGroup!=null && this.comapniesUnderGroup.length>0)
          this.cgName = this.comapniesUnderGroup[0].cgName;

          for (let i = 0; i < this.comapniesUnderGroup.length; i++) {
            this.custMasterList.push(this.comapniesUnderGroup[i].custId);
          }

          this.companyGroupForm.controls.CompanyNames.setValue(this.custMasterList);
        }
      }
          
    );
  }

  get f() { return this.companyGroupForm.controls; }

  onList(): void {
    this._router.navigate(['companyGroup']);
  }

  getCompanyList(custid = 0) {   
   
    this.custservice.getCustomerMasterList(custid, true).subscribe(
      (data) => {
        if (data['isError'] === false && data['code'] === 200) {

          this.allCustArr = data['payload'];
          if(this.CgId>0){
          for(let i=0; i< this.allCustArr.length; i++)
          {           
            if(this.allCustArr[i].cgId > 0 && !this.comapniesUnderGroup.find(b=>b.custId == this.allCustArr[i].custId))
            {             
              //this.allCustArr.splice(i,1);
            }
          }
        }else{
          for(let i=0; i<this.allCustArr.length; i++)
          {           
            if(this.allCustArr[i].cgId > 0)
            {             
              //this.allCustArr.splice(i,1);
            }
          }
        } 

        // this.allCustArr = this.allCustArr.sort([compareFunction]);

       this.allCustArr.sort(function(a, b) {
          var textA = a.customerName.toUpperCase();
          var textB = b.customerName.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });

        } else {
          this.allCustArr = [];
          this.custArr = [];
        }
      },
    );
  }

  // getCompanyList(custid = 0) {   
  //   this.custservice.getCustomerMasterList(custid, true).subscribe((data) => {
  //     if (data['isError'] === false && data['code'] === 200) {
  //       this.allCustArr = data['payload'];
  //       if (this.CgId > 0) {
  //         this.allCustArr = this.allCustArr.filter(cust => 
  //           cust.cgId < 0  && !this.comapniesUnderGroup.find(b => b.custId == cust.custId)
  //         );
  //         // for(let i=0; i< this.allCustArr.length; i++)
  //         //            {           
  //         //              if(this.allCustArr[i].cgId > 0 && !this.comapniesUnderGroup.find(b=>b.custId == this.allCustArr[i].custId))
  //         //              {             
  //         //                this.allCustArr.splice(i,1);
                         
  //         //              }
                     
  //         //            }
  //       } else {
  //         this.allCustArr = this.allCustArr.filter(cust => cust.cgId <= 0);
  //       }
  
  //       // Sorting by customerName
  //       this.allCustArr.sort((a, b) => {
  //         const textA = a.customerName.toUpperCase();
  //         const textB = b.customerName.toUpperCase();
  //         return textA < textB ? -1 : textA > textB ? 1 : 0;
  //       });
  
  //     } else {
  //       this.allCustArr = [];
  //       this.custArr = [];
  //     }
  //   });
  // }
  
  onSubmit() {
   
    this.submitted = true;
    if (this.companyGroupForm.valid) {
      this.isDisabled = true;
      this.loading = true;
      const objcompanyGrpRM: CompanyGroup = new CompanyGroup();
      // custRegGrp: Array<CustomerRegistrationCompanyGroup>();     
      objcompanyGrpRM.Ins_By = this._auth.getUserId();
      objcompanyGrpRM.CGName = this.companyGroupForm.controls['GroupName'].value;
      objcompanyGrpRM.CRCompanyGroup = Array<CustomerRegistrationCompanyGroup>();
      objcompanyGrpRM.IsActive = true;
      let cgid = this.CgId || 0;
      this.custNameArr.forEach(function(item) {
        const custRegGrp: CustomerRegistrationCompanyGroup = new CustomerRegistrationCompanyGroup();
        custRegGrp.CGId = cgid;
        custRegGrp.CustId = item;
        objcompanyGrpRM.CRCompanyGroup.push(custRegGrp);
      });         

      this.custservice.companyGroupCRRUpd(objcompanyGrpRM, cgid).subscribe(
        (data) => {
          
          if (data['isError'] === false && data['code'] === 200) {
            // this.CgId = data['payload'];
            this.commonfunction.showToast('success', 'Success', 'Successfully saved');
            
            const objULog: UserLog = new UserLog();
            objULog.Action = (this.CgId > 0 ? 'Edit' : 'Create') + ' Customer User';
            objULog.UserId = this._auth.getUserId();
            objULog.PageName = (this.CgId > 0 ? 'companyGrpEdit' : 'companyGrpCreate');
            objULog.Notes = 'CgId=' + this.CgId;

            this.commservice.insertUserLog(objULog).subscribe(data3 => {
              // do something, success
            }, error => { alert(error); });

            setTimeout(() => {             
              this._router.navigate(['companyGroup']);
            }, 1500);
          } else {
            this.commonfunction.showToast('danger', 'Failed', 'Not saved');
            this.isDisabled = false;
          }
          this.loading = false;
        },
      );
    }
  }


  onReset() {
    this.submitted = false;
    // let idstr: string = '';
    if(this.CgId > 0)
    {
    //   const obj = {
    //     cgId: this.CgId,
    //   };
    //   idstr = this._auth.encryptData(obj);
    //   this._router.navigate(['companyGroupCreate/' + idstr]);
      // this.getCompanyList(0);
      this.SetFormData(this.CgId); 
     
      // this.companyGroupForm.controls.CompanyNames.setValue(this.custMasterList);
    }else{
      this.cgName = '';
      this.getCompanyList(0);
      this.custNameArr = [];
      this.allCustArr = [];
      this.custMasterList = [];
      this.companyGroupForm.controls.CompanyNames.setValue(this.custMasterList);
    }
    
  }

  selectedCompanies(a: any) {
    if (a.length > 0) {
      this.custNameArr = [];
      for (let i = 0; i < a.length; i++) {
        const custId = this.allCustArr.filter(t => t.custId === a[i])[0]['custId'];
        this.custNameArr.push(custId); 
      }
    }
  }
}
